import React from 'react';
import {Button, DatePicker, Form, Input, message} from 'antd';
import useCollectionWork, {CollectionWorkProjectType, ICollectionWork} from '../../hooks/apis/useCollectionWork';
import useCollectionWorkProject from '../../hooks/apis/useCollectionWorkProject';
import moment, {Moment} from 'moment';
import {CollectionWorkProjectStatusConfig} from '../../hooks/apis/useCollectionWorkProjectRecord';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import CollectionWorkProjectStatusConfigSelector from '../CollectionWorkProject/StatusConfigSelector';
import CollectionWorkProjectList from '../CollectionWorkProject/List';
interface ICollectionWorkEditForm {
  id: number;
  beginTime: Moment;
  endTime: Moment;
  statusConfig: CollectionWorkProjectStatusConfig;
}
const CollectionWorkEditForm = (props: {collectionWork?: ICollectionWork; onFinish?: (form: ICollectionWorkEditForm) => any}) => {
  const submitHook = useCollectionWork.save();
  const [form] = Form.useForm();
  const defaultForm: ICollectionWorkEditForm = {
    id: props.collectionWork?.id || 0,
    beginTime: moment(),
    endTime: moment().add(1, 'day'),
    statusConfig: CollectionWorkProjectStatusConfig.关闭,
  };

  React.useEffect(() => {
    if (props.collectionWork) {
      form.setFieldsValue({
        ...props.collectionWork,
        beginTime: moment(props.collectionWork.beginTime),
        endTime: moment(props.collectionWork.endTime),
      });
    } else {
      form.setFieldsValue(defaultForm);
    }
  }, [props.collectionWork]);

  function submit(value: ICollectionWorkEditForm) {
    value.id = props.collectionWork?.id || 0;
    submitHook
      .request({...value, beginTime: value.beginTime.format('YYYY-MM-DD HH:mm:ss'), endTime: value.endTime.format('YYYY-MM-DD HH:mm:ss')})
      .then(res => {
        message.success('修改成功');
        form.setFieldsValue({
          ...res,
          beginTime: moment(res.beginTime),
          endTime: moment(res.endTime),
        });
      })
      .catch(CommonApiErrorHandler);
  }
  return (
    <div>
      <Form labelCol={{span: 6}} wrapperCol={{span: 14}} layout={'horizontal'} form={form} onFinish={submit}>
        <Form.Item label={'开始时间'} name={'beginTime'} rules={[{required: true}]}>
          <DatePicker showTime size={'large'} placeholder="请输入开始时间" />
        </Form.Item>
        <Form.Item label={'结束时间'} name={'endTime'} rules={[{required: true}]}>
          <DatePicker showTime size={'large'} placeholder="请输入结束时间" />
        </Form.Item>
        <Form.Item label={'通道开关'} name={'statusConfig'} rules={[{required: true}]}>
          <CollectionWorkProjectStatusConfigSelector />
        </Form.Item>
        <Form.Item label={'保存'}>
          <Button loading={submitHook.loading} htmlType={'submit'} type={'primary'}>
            保存设置
          </Button>
        </Form.Item>
      </Form>
      <CollectionWorkProjectList collectionWorkId={props.collectionWork?.id} />
    </div>
  );
};
export default CollectionWorkEditForm;
